var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnUsername(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-smile",
    "data-name": "001-smile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.396,
    height: 14.396,
    viewBox: "0 0 14.396 14.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M7.2,0a7.2,7.2,0,1,0,7.2,7.2A7.2,7.2,0,0,0,7.2,0Zm0,13.368a6.17,6.17,0,1,1,6.17-6.17A6.17,6.17,0,0,1,7.2,13.368Z",
    fill: "#666"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(3.599 5.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.028,
    cy: 1.028,
    r: 1.028,
    fill: "#666"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(8.741 5.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.028,
    cy: 1.028,
    r: 1.028,
    fill: "#666"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(5.127 8.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M174.229,289.956a.514.514,0,0,0-.72-.1l-.029.023h0a2.069,2.069,0,0,1-2.441,0,.514.514,0,0,0-.672.778l.029.023a3.07,3.07,0,0,0,3.729,0A.514.514,0,0,0,174.229,289.956Z",
    transform: "translate(-170.189 -289.75)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUsername);
export default __webpack_public_path__ + "static/media/icn_username.80d4f970.svg";
export { ForwardRef as ReactComponent };